import React from 'react';
import EngineeringLogic from './EngineeringLogic';
import {Layout, Tabs, Card} from 'antd';
import appColors from '../../style/theme';
const {Content} = Layout;
const items_ = [
  {label: <Card
    style={{
      width: 300,
      background: appColors['ColorA'],
      margin: '-8px -16px -10px -16px',
    }}
    cover={
      <img
        src="https://static.igem.wiki/teams/4464/wiki/home/overview6.png"
        height = "300vh"
      />
    }
  >
  </Card>, key: 'fh', children: <EngineeringLogic/>},
];

const EngineeringPage = () => {
  return (
    <Layout style={{background: 'transparent'}}>
      <Content>
        <Tabs
          centered='true'
          defaultActiveKey="1"
          type="card"
          items={items_}
        />
      </Content>
    </Layout>
  );
};

export default EngineeringPage;
